import { ReactNode, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { getEntity } from 'app/state/ducks/entities/selectors'
import { loadOneEntity } from 'app/state/ducks/entities/thunks'
import { ContractType } from 'app/models/common-types'
import { loadNotesByContract } from 'app/state/ducks/notes/thunks'
import { DataBoxLayout } from 'app/views/components/detailSections/data-box-layout'
import { DetailSection } from 'app/views/components/detailSections/detail-section'
import { DetailSectionHeader } from 'app/views/components/detailSections/detail-section-header'
import { getEntityProfiles } from 'app/state/ducks/entity-profile/selectors'
import { getEntityTypes } from 'app/state/ducks/entity-type/selectors'
import { buildEntityDetailsObject } from 'app/views/components/functions/buildDetailsObjects'
import EntityServiceProvidersTable from './entity-service-providers-table'
import { getBusinessDate } from 'app/state/ducks/business-date/selectors'


export default function EntityPage() {
    const dispatch = useDispatch()
    const { entityId, status } = useParams()
    const entity = useSelector(getEntity)
    const entityProfiles = useSelector(getEntityProfiles)
    const entityTypes = useSelector(getEntityTypes)
    const businessDate = useSelector(getBusinessDate)

    useEffect(() => {
        if (entityId) {
            dispatch(loadOneEntity(entityId, status ?? 'Inactive'))
            dispatch(loadNotesByContract(entityId, ContractType.Entities))
        }
    }, [entityId])


    const isTaxFormExpired = entity?.taxFormExpirationDate
        ? new Date(entity.taxFormExpirationDate) < businessDate
        : false

    const { entityDetails, addressDetails, identifiersDetails, taxDetails, signatureBlock, signatory } = buildEntityDetailsObject(entity, entityProfiles, entityTypes, isTaxFormExpired)

    const renderDetailSection = (headerText: string, detailObjArr: any, columnCount = 3) => (
        <>
            <DetailSectionHeader headerText={headerText} />
            <DetailSection detailObjArr={detailObjArr} columnCount={columnCount} />
        </>
    );

    const renderTableSection = (headerText: string, tableSection: ReactNode) => (
        <>
            <DetailSectionHeader headerText={headerText} />
            {tableSection}
        </>
    );



    return (
        <DataBoxLayout
            sections={[
                [
                    renderDetailSection('Details', entityDetails),
                    renderDetailSection('Address', addressDetails)
                ],
                [
                    renderDetailSection('Identifiers', identifiersDetails),
                    renderDetailSection('Tax', taxDetails)
                ],
                [
                    renderDetailSection('Signature Block', signatureBlock),
                    renderDetailSection('Signatory', signatory, 1)
                ]
            ]}
            tableSections={[renderTableSection('Service Providers', <EntityServiceProvidersTable />)]}
        />
    )
}